import { SurveyCreator } from 'survey-creator-react';
import CustomWidget from 'vl-md/src/CustomSurvey/customWidgets/CustomWidget';
import { JsonObject } from 'survey-core';

/** Renders a custom action button which is used to interpret what outcome is necessary from the survey inputs and leads to the appropriate action on button press. */
const CustomizeSurveyPrevQuestion = (surveyCreator?: SurveyCreator) => {
  const activatedByChangeHandler = () => {
    JsonObject.metaData.addClass('prevquestion', [], null, 'empty');
    JsonObject.metaData.addProperties('prevquestion', [
      {
        name: 'SurveyCode',
        category: 'general'
      },
      {
        name: 'QuestionName',
        category: 'general'
      }
    ]);
  };

  const afterRenderHandler = (question, el) => {};
  const htmlTemplate = '<div data-testid="customized-prevquestion-component"><div></div></div>';
  const widgetIconName = 'icon-expression';
  CustomWidget({
    htmlTemplate,
    name: 'prevquestion',
    title: 'Previous Question',
    activatedByChangeHandler,
    afterRenderHandler,
    iconName: widgetIconName,
    surveyCreator
  });
};

export default CustomizeSurveyPrevQuestion;
